import { FromSchema } from '@40seas/entities/common';
import { z } from 'zod';

export const NegativeBalanceDaysProcessPayloadSchema = z.object({
    days: z.number().optional(),
});

export class NegativeBalanceDaysProcessPayload extends FromSchema(NegativeBalanceDaysProcessPayloadSchema) {
    days?: number;
}
